const STORAGE_KEY = 'biz_debug_overlay';
const CORNER_SIZE = 48;
const TAPS_NEEDED = 7;
const WINDOW_MS = 3000;
const ALLOWED_EMAILS = ['sagih@d.co.il'];

function currentEmail() {
    try {
        const token = sessionStorage.getItem('biz-jwt-token');
        if (!token) return null;
        return JSON.parse(atob(token.split('.')[1])).Email;
    } catch {
        return null;
    }
}

function isAllowed() {
    return ALLOWED_EMAILS.includes(currentEmail());
}

function loadEruda() {
    return new Promise((resolve, reject) => {
        if (window.eruda) return resolve(window.eruda);
        const s = document.createElement('script');
        s.src = 'https://cdn.jsdelivr.net/npm/eruda';
        s.onload = () => resolve(window.eruda);
        s.onerror = reject;
        document.head.appendChild(s);
    });
}

async function enable() {
    try {
        const eruda = await loadEruda();
        eruda.init();
        localStorage.setItem(STORAGE_KEY, '1');
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error('eruda failed to load', e);
    }
}

function disable() {
    if (window.eruda) window.eruda.destroy();
    localStorage.removeItem(STORAGE_KEY);
}

function mountTrigger() {
    let taps = [];
    const onTap = (e) => {
        const touch = e.touches && e.touches[0];
        const x = touch ? touch.clientX : e.clientX;
        const y = touch ? touch.clientY : e.clientY;
        if (x > CORNER_SIZE || y > CORNER_SIZE) {
            taps = [];
            return;
        }
        const now = Date.now();
        taps = taps.filter((t) => now - t < WINDOW_MS);
        taps.push(now);
        if (taps.length >= TAPS_NEEDED) {
            taps = [];
            if (!isAllowed()) return;
            if (localStorage.getItem(STORAGE_KEY) === '1') disable();
            else enable();
        }
    };
    document.addEventListener('touchstart', onTap, true);
    document.addEventListener('click', onTap, true);
}

export function initDebugOverlay() {
    if (localStorage.getItem(STORAGE_KEY) === '1' && isAllowed()) enable();
    if (document.body) mountTrigger();
    else document.addEventListener('DOMContentLoaded', mountTrigger);
}
